import React from "react";
import styled from "styled-components";
import { ReactComponent as SuccessIcon } from "../../../assets/icons/Success.svg";
import { ReactComponent as ErrorIcon } from "../../../assets/icons/Error.svg";
import { ReactComponent as QuestionIcon } from "../../../assets/icons/Question.svg";
import { ReactComponent as AlarmIcon } from "../../../assets/icons/Caution.svg";
import { theme } from "../../../theme";
import { StatusType } from "./constants";
import { ValidationType } from "./types";

interface Props extends ValidationType {
  onClick?: () => void;
  color?: string;
  isNotShowText?: boolean;
}

const Explain: React.FC<Props> = ({
  status,
  explain,
  onClick,
  color,
  isNotShowText,
}) => {
  return (
    <StyledExplainWrapper>
      <StyledExplainIconWrapper>
        {isNotShowText ? " " : status && <ExplainIcons status={status} />}
      </StyledExplainIconWrapper>
      <StyledExplainTextWrapper color={color} status={status} onClick={onClick}>
        {isNotShowText ? " " : explain}
      </StyledExplainTextWrapper>
    </StyledExplainWrapper>
  );
};
export default Explain;
const ExplainIcons: React.FC<{ status?: StatusType }> = ({ status }) => {
  switch (status) {
    case "error":
      return <ErrorIcon />;
    case "success":
      return <SuccessIcon />;
    case "caution":
      return <AlarmIcon />;
    case "question":
    default:
      return <QuestionIcon />;
  }
};
const StyledExplainWrapper = styled.div<{
  status?: StatusType;
}>`
  margin-top: 4px;
  display: flex;
  width: 100%;
  ${theme.typo.body.r14}
  color:${({ status }) => {
    switch (status) {
      case "success":
        return theme.colors.blue2;
      case "error":
        return theme.colors.red3;
      default:
        return theme.colors.gray1;
    }
  }};
`;
const StyledExplainTextWrapper = styled.span<{
  status?: StatusType;
  color?: string;
}>`
  line-height: 24px;

  margin-left: 6px;
  color: ${({ onClick, color }) =>
    color || (onClick && theme.colors.mainPrimary3)};
  cursor: ${({ onClick }) => onClick && "pointer"};
  color: ${({ status, color }) => {
    switch (status) {
      case "success":
        return theme.colors.blue2;
      case "error":
        return theme.colors.red3;
      default:
        return color || theme.colors.gray1;
    }
  }};
`;
const StyledExplainIconWrapper = styled.div`
  display: flex;
  align-items: center;

  justify-content: center;

  flex-direction: column;
  height: 24px;
`;
